import React from 'react'
import PropTypes from 'prop-types'
import { Pagination as SemanticPagination } from 'semantic-ui-react'
import classnames from 'classnames/bind'
import styles from './styles.scss'
const cx = classnames.bind(styles)

const Pagination = props => {
  const { elmId = 'pagination', footer, className, ...rest } = props
  return (
    <div data-elm-id={elmId} className={cx('pagination-container')}>
      <SemanticPagination {...rest} className={cx('pagination', className)} />
      {footer}
    </div>
  )
}

Pagination.propTypes = {
  elmId: PropTypes.string,
  footer: PropTypes.node,
  className: PropTypes.string,
}

Pagination.propsTypes = SemanticPagination.propsTypes

export default Pagination
